"use client";

export default function CookieSettings() {
  return (
    <button type="button" className="footer-link-btn" onClick={() => window.dispatchEvent(new Event("lw:open-consent"))}>
      Cookie settings
    </button>
  );
}
